export default function loadNewRelic() {
  try {
    const script = document.createElement('script')
    script.src = 'https://js-agent.newrelic.com/nr-spa-1.293.0.min.js'
    script.async = true
    script.onload = () => {
      console.debug('New Relic loaded')
    }
    script.onerror = (err) => {
      console.warn('New Relic failed to load', err)
    }
    document.head.appendChild(script)
  } catch (e) {
    console.warn('Failed to initialise New Relic', e)
  }
}
